<template>
  <header id="header">
    <div class="inner_static">
      <ul id="hnb">
        <li>
          <a class="btn_intro" @click="btnIntroClick()">カグルとは？</a>
        </li>
        <li>
          <a class="btn_faq" @click="btnFaqClick()">FAQ</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    btnIntroClick: function () {
      this.$router.push('/kagull/about/0')
    },
    btnFaqClick: function () {
      this.$router.push('/kagull/faq/0')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/login/LoginHeader.vue